import { render, staticRenderFns } from "./TariffCalculatorForm.vue?vue&type=template&id=18d74673&"
import script from "./TariffCalculatorForm.vue?vue&type=script&lang=js&"
export * from "./TariffCalculatorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports